import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { Field, reduxForm, InjectedFormProps, change, getFormSyncErrors } from 'redux-form';
import { getUserProfile, deactivateUser } from 'modules/user/userprofile';
import * as c from 'models/constants';
import { IUserProfile, IUserProfileAction, IUserProfileData } from 'models/user/userprofile';

import { actions as notifActions } from 'redux-notifications';

const { notifSend } = notifActions;
require('../UserProfile/style.css');
import { putUserPreferences, sendVerificationEmail } from 'redux/modules/user/userpreferences';
import { ManageUserWrapper } from '..';
import { IModalAction } from 'models/modal';
import { IUserPreferences, IUserPreferencesAction } from 'models/user/userpreferences';
import { Button, ErrorSummary, LoadingOverlayWrapper } from 'components';
import { InjectedRouter } from 'react-router';
import { PortalPageSection } from 'components/PortalStructure';
import { PortalSelectMenu, PortalSwitchField } from 'components/FormControls';
import { EllipseGreyBlackButton } from 'components/Common/Button';
import { closeModal, showModal } from 'redux/modules/modal';
import { getCategoryDomainValues } from 'redux/modules/domainvalues';
import { IAuthContext, ILanguage } from 'models/common';
import { IUserLanguage } from 'models/user/userlanguage';
import { MenuItemType } from 'models/enums/menuitemtype';
import { IMainMenuAction } from 'models/mainmenu/mainmenu';
import { changeLanguage } from 'redux/modules/user/userlanguage';
import renderIcon from 'helpers/renderIcon';
import { required } from 'helpers/validationattributes';
import { createLanguageDropdownValues } from 'helpers/common';

interface IProps extends InjectedFormProps {
	userProfile: IUserProfileData;
	userPreferences?: IUserPreferences;
	initialValues: IUserProfile;
	currentFormValues: IUserProfile;
	location: any;
	baseUrlClient?: string;
	router: InjectedRouter;
	route: any;
	languageDomainValues?: ILanguage[];
	userLanguage?: IUserLanguage;
	context: IAuthContext;
	baseApi?: string;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	t?: (key: string, props?: any) => string;
	change: (field: string, data: any) => void;
	reset?: () => void;
	getUserProfile: () => IUserProfileAction;
	putUserPreferences: (userPreferences: IUserPreferences) => IUserPreferencesAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	deactivateUser?: () => void;
	notifSend?: (data: any) => void;
	sendVerificationEmail?: () => IUserPreferencesAction;
	changeLanguage: (language: number, updateUserPreferences: boolean) => IUserLanguage;
	getPublishedMenuItems: (menuItemType: MenuItemType) => IMainMenuAction;
}

interface IState {
	readOnlyPrivacy: boolean;
	readOnlyPreference: boolean;
	hasResentVerificationEmail: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserAccountForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
		this.toggleReadOnlyPrivacy = this.toggleReadOnlyPrivacy.bind(this);
		this.toggleReadOnlyPreference = this.toggleReadOnlyPreference.bind(this);
		this.openDeactivateUser = this.openDeactivateUser.bind(this);
		this.onChangePassword = this.onChangePassword.bind(this);

		this.state = {
			readOnlyPrivacy: true,
			readOnlyPreference: true,
			hasResentVerificationEmail: false,
		};
	}

	public componentDidMount() {
		this.props.getUserProfile();
	}

	private sendVerificationEmail(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.sendVerificationEmail();
		this.setState({ hasResentVerificationEmail: true });
	}

	private toggleReadOnlyPrivacy() {
		this.setState((s) => {
			this.props.reset();
			return {
				readOnlyPrivacy: !s.readOnlyPrivacy,
				readOnlyPreference: true,
			};
		});
	}

	private toggleReadOnlyPreference() {
		this.setState((s) => {
			this.props.reset();
			return {
				readOnlyPreference: !s.readOnlyPreference,
				readOnlyPrivacy: true,
			};
		});
	}

	private renderReadOnlyPrivacy() {
		const { t, userPreferences } = this.props;

		return (
			<dl className="list">
				<dt>{t('User_UserAccount_Label_ProfilePrivacy')}</dt>
				<dd className="bold">
					{userPreferences?.isPublic === false ? (
						<>{t('User_UserAccount_Value_ProfilePrivacyPrivate')}</>
					) : (
						<>{t('User_UserAccount_Value_ProfilePrivacyPublic')}</>
					)}
				</dd>
				<dt />
				<dd className="size-14">
					{t(`User_UserAccount_About_ProfilePrivacy${userPreferences?.isPublic ? 'Public' : 'Private'}Desc`)}
				</dd>
			</dl>
		);
	}

	private renderEditablePrivacy() {
		const { t } = this.props;

		return (
			<>
				<p>{t('User_UserAccount_AboutEdit_ProfilePrivacy')}</p>
				<Field
					name="isPublic"
					component={PortalSwitchField}
					type="checkbox"
					label={t('User_UserAccount_Value_ProfilePrivacyPublic')}
				/>
				<Button className="formButton" type="submit">
					{t('BSPortal_Common_Save')}
				</Button>
			</>
		);
	}

	private renderReadOnlyPreference() {
		const { t, languageDomainValues, userLanguage } = this.props;

		const selectedLanguageKey = userLanguage.languageKey || '1'; // On reload the value is not found immediately so we set a default value here (svg below caused crashes before)
		let selectedLanguageName = '';
		if (selectedLanguageKey && languageDomainValues) {
			selectedLanguageName = languageDomainValues.find((v) => v.key === selectedLanguageKey)?.value || '';
		}

		return (
			<>
				<dl className="list">
					<dt>{t('User_UserPreferences_Label_Language')}</dt>
					<dd className="bold">
						{selectedLanguageName}
						<img
							src={require(`../../../components/Common/LanguageDropdown/flags/${selectedLanguageKey}.svg`)}
							alt={selectedLanguageName}
						/>
					</dd>
				</dl>
			</>
		);
	}

	private renderEditablePreference() {
		const { t, languageDomainValues } = this.props;
		const languages = createLanguageDropdownValues(languageDomainValues, t);

		return (
			<>
				<Field
					name="languageKey"
					component={PortalSelectMenu}
					parse={(value) => (value ? Number(value) : null)}
					items={languages}
					type="number"
					label={t('User_UserPreferences_Label_Language')}
					validate={[required]}
					isRequired={true}
					searchable={false}
				/>
				<Button className="formButton" type="submit">
					{t('BSPortal_Common_Save')}
				</Button>
			</>
		);
	}

	public onSubmit(form: IUserPreferences) {
		this.setState({
			readOnlyPrivacy: true,
			readOnlyPreference: true,
		});

		if (form.languageKey) {
			this.props.changeLanguage(parseInt(form.languageKey.toString(), 10), false);
		}
		this.props.putUserPreferences(form);
	}

	private onChangePassword() {
		const baseUrlClient = this.props.baseUrlClient;
		const baseApi = this.props.baseApi;
		const changePasswordLink =
			baseApi +
			'userenter/changepassword?returnUrl=' +
			baseUrlClient +
			'/userprofile?passwordchanged=true%26userId=' +
			this.props.userPreferences.id;
		window.location.href = changePasswordLink;
	}

	private mapErrorKeyToMessage(key: string, t: (key: string) => string) {
		switch (key) {
			case 'givenName':
				return t('User_UserProfile_Label_GivenName');
			case 'familyName':
				return t('User_UserProfile_Label_FamilyName');
			case 'website':
				return t('User_UserProfile_Label_Website');
			default:
				return key;
		}
	}

	private openDeactivateUser(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.showModal('DeactivateUser', {
			closeModal: this.props.closeModal,
			deactivateUser: this.props.deactivateUser,
			baseUrlClient: this.props.baseUrlClient,
		});
	}

	public render() {
		const { t, initialValues, formErrors, submitFailed, handleSubmit, userPreferences } = this.props;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error: this.props.userProfile ? this.props.userProfile.error : false,
			message: this.props.userProfile ? this.props.userProfile.message : null,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		return (
			<ManageUserWrapper user={initialValues}>
				<br />
				<div className="userProfileEditForm">
					<LoadingOverlayWrapper
						active={this.props.userProfile.isFetching}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						<div className="profileError">
							<ErrorSummary {...errorSummaryProps} />
						</div>

						<form onSubmit={handleSubmit(this.onSubmit)} className="editForm">
							{/* <Field name="id" component="input" type="hidden" /> */}
							<PortalPageSection
								title={t('User_UserAccount_Privacy')}
								readOnly={this.state.readOnlyPrivacy}
								toggleEdit={this.toggleReadOnlyPrivacy}
							>
								{this.state.readOnlyPrivacy ? this.renderReadOnlyPrivacy() : this.renderEditablePrivacy()}
							</PortalPageSection>
							<PortalPageSection
								title={t('User_UserPreferences_Title')}
								readOnly={this.state.readOnlyPreference}
								toggleEdit={this.toggleReadOnlyPreference}
							>
								{this.state.readOnlyPreference ? this.renderReadOnlyPreference() : this.renderEditablePreference()}
							</PortalPageSection>
							<PortalPageSection title={t('User_UserPreferences_LoginInfo')} variant="dark">
								<dl className="list">
									<dt>{t('User_UserPreferences_Label_Email')}</dt>
									<dd className="bold">{userPreferences.email}</dd>
									<dd className="size-14">
										{userPreferences?.emailVerified ? (
											<>
												{renderIcon('check1')}
												{t('User_UserPreferences_Verified')}
											</>
										) : (
											<>
												{renderIcon('alert')}
												{t('User_UserPreferences_Unverified')}
											</>
										)}
									</dd>
									<dd className="size-14">
										{!userPreferences?.emailVerified && !this.state.hasResentVerificationEmail ? (
											<div className="list__resendVerification" onClick={this.sendVerificationEmail}>
												{t('User_UserPreferences_Resend_Verification_Email')}
											</div>
										) : null}
									</dd>
								</dl>
								<EllipseGreyBlackButton onClick={this.onChangePassword}>
									{t('User_UserProfile_ChangePassword')}
								</EllipseGreyBlackButton>
							</PortalPageSection>
							<PortalPageSection title={t('User_UserAccount_DeleteAccount')} variant="dark">
								<p>{t('User_UserAccount_DeleteAccount_About')}</p>
								<EllipseGreyBlackButton onClick={this.openDeactivateUser}>
									{t('User_UserProfile_DeactivateAccount')}
								</EllipseGreyBlackButton>
							</PortalPageSection>
						</form>
					</LoadingOverlayWrapper>
				</div>
			</ManageUserWrapper>
		);
	}
}

let UserAccount = reduxForm({
	form: c.FORM_NAME_USERPREFERENCES,
	enableReinitialize: true,
})(UserAccountForm);

UserAccount = connect(
	(state: IStore) => {
		return {
			initialValues: state.userPreferences,
			userProfile: state.userprofile,
			userPreferences: state.userPreferences,
			formErrors: getFormSyncErrors(c.FORM_NAME_USERPREFERENCES)(state),
			baseUrlClient: state.fetchDefault.baseUrlClient,
			baseApi: state.fetchDefault.baseAPI,
			languageDomainValues: state.domainValues.languages,
			userLanguage: state.userLanguage,
		};
	},
	(dispatch) => ({
		putUserPreferences: (form: IUserPreferences) => dispatch(putUserPreferences(form)),
		change: (field: string, value: any) => dispatch(change(field, value)),
		deactivateUser: () => dispatch(deactivateUser()),
		getUserProfile: () => dispatch(getUserProfile()),
		notifSend: (data: any) => dispatch(notifSend(data)),
		sendVerificationEmail: () => dispatch(sendVerificationEmail()),
		showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
		closeModal: () => dispatch(closeModal()),
		getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
		changeLanguage: (language: number, updateUserPreferences: boolean) =>
			dispatch(changeLanguage(language, updateUserPreferences)),
	}),
)(UserAccount);

export { UserAccount };
